import React from 'react'
import PropTypes from 'prop-types'
import InlineIcon from '../../InlineIcon/InlineIcon.jsx'
import SupportModal from '../SupportModal/SupportModal.jsx'
import './SupportButton.scss'

const SupportButtonView = ({ showHelp, toggleHelpModal, shouldRender }) => {
  if (!shouldRender) return null

  return (
    <div className='support-button-overlay'>
      <button
        type='button'
        className='support-button'
        onClick={toggleHelpModal}
      >
        <span className='support-button__icon'>
          <InlineIcon name='mail' />
        </span>
        Contact Support
      </button>
      {showHelp && <SupportModal onClose={toggleHelpModal} />}
    </div>
  )
}

SupportButtonView.propTypes = {
  showHelp: PropTypes.bool.isRequired,
  toggleHelpModal: PropTypes.func.isRequired,
  shouldRender: PropTypes.bool.isRequired,
}

export default SupportButtonView
